import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { getToken } from "../../utils/tokenUtils";
import { Link } from "react-router-dom";
import Notification from "../../components/UI/Notification";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { AuthContext } from "../../contexts/AuthContext";

const CheckLeaveBalance = () => {
  const [leaveData, setLeaveData] = useState(null);
  const [userId, setUserId] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = getToken();
  const [notification, setNotification] = useState(null);
  const { roles } = useContext(AuthContext);

  const getRoleBasedRouteLocal = (route) => {
    return getRoleBasedRoute(route, roles);
  };


  const fetchLeaveDetails = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const url = "https://hrmspayroll.prepstripe.com/api/authuser/leave-details";

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const filteredData = Object.fromEntries(
        Object.entries(response.data.data || {}).filter(
          ([key]) =>
            ![
              "created_at",
              "updated_at",
              "is_on_notice",
              "user_name",
              "user_id",
              "id",
            ].includes(key)
        )
      );

      setLeaveData(filteredData);
      // setNotification(`Leave details fetched successfully for Logged-In User`);
      // setNotification({
      //     message: "Leave details fetched successfully for Logged-In User",
      //     type: "success"
      // });
    } catch (err) {
      // setError("Failed to fetch leave details.");
      // setNotification({
      //     message: err?.response.data.message || "Failed to fetch leave details. Please check the employee ID.",
      //     type: "error"
      // });
      setLeaveData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchLeaveDetails("");
    }
  }, [token]);

  return (
    <div className="p-4 sm:p-6 bg-white dark:bg-gray-900 rounded-lg">
            
      {/* notification compo */}
        {notification && (
          <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
      )}
      
      {/* Breadcrumb */}
      <nav className="flex flex-wrap mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li>
            <div className="flex items-center">
              <Link
                to={getRoleBasedRouteLocal("/admin/attendance_management")}
                className="text-sm sm:text-md font-medium text-gray-700 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
              >
                Attendance Management
              </Link>
            </div>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg
                className="w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="ms-1 text-sm sm:text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                Leave Balance
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <h2 className="text-lg sm:text-xl font-semibold mb-4 dark:text-white">
        Leave Balance
      </h2>

      {/* data table */}
      <div className="overflow-x-auto bg-white dark:bg-gray-900  shadow-md rounded-lg">
        <table className="min-w-full table-auto md:table-fixed text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white"> 
            <tr>
              <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-black whitespace-nowrap">
                Sr No.
              </th>
              <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-black whitespace-nowrap">
                Leave Type
              </th>
              <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-black whitespace-nowrap">
                Balance
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="6"
                  className="dark:border-gray-700 text-center p-3 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white"
                >
                  Loading...
                </td>
              </tr>
            ) : leaveData && Object.keys(leaveData).length > 0 ? (
              Object.entries(leaveData)
                .filter(([key]) => key !== "employee_id") // Exclude employee_id
                .map(([key, value], index) => (
                  <tr key={key} className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white">
                    <td className="p-2 text-left whitespace-nowrap font-medium">
                      {index + 1}
                    </td>
                    <td className="p-2 text-left whitespace-nowrap">
                      {key.replace(/_/g, " ")}
                    </td>
                    <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                      {value}
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="dark:border-gray-700 text-center p-3 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white"
                >
                  No leave data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* {error && <p className="text-red-500 mt-4">{error}</p>} */}
    </div>
  );
};

export default CheckLeaveBalance;
